/**
 * Checks if the store is currently open based on hardcoded schedule.
 * Returns an object with the status for Eat-in and General/Takeaway.
 */
export function checkStoreStatus() {
  const timeZone = 'Europe/London'; 
  const now = new Date();
  
  const dayParts = new Intl.DateTimeFormat('en-GB', { 
    timeZone, 
    hour: 'numeric', 
    minute: 'numeric', 
    hourCycle: 'h23'
  }).formatToParts(now);

  const dayOfWeekFormatter = new Intl.DateTimeFormat('en-GB', { 
    timeZone, 
    weekday: 'long' 
  }).format(now);

  // Convert weekday string to numeric mapping (0=Sun, 1=Mon, ..., 6=Sat)
  const daysMap = {
    'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3,
    'Thursday': 4, 'Friday': 5, 'Saturday': 6
  };
  const dayOfWeek = daysMap[dayOfWeekFormatter] ?? now.getDay();

  const currentHour = parseInt(dayParts.find(p => p.type === 'hour')?.value || '0', 10);
  const currentMinute = parseInt(dayParts.find(p => p.type === 'minute')?.value || '0', 10);
  
  const currentTime = currentHour + (currentMinute / 60);
  
  // Default: manually managed (Saturdays = 6)
  if (dayOfWeek === 6) {
    return {
      isEatInOpen: true,
      isTakeawayOpen: true
    };
  }

  // Open at 12:00 PM
  const OPENING_TIME = 12.00; 

  if (currentTime < OPENING_TIME) {
    return { isEatInOpen: false, isTakeawayOpen: false };
  }

  // Fridays stay open until manually closed
  if (dayOfWeek === 5) {
    return {
      isEatInOpen: true,
      isTakeawayOpen: true
    };
  }

  let eatInCloseTime = 21.5;     // Default fallback
  let takeawayCloseTime = 21.75; // Default fallback

  if (dayOfWeek >= 1 && dayOfWeek <= 4) {
    // Monday to Thursday
    eatInCloseTime = 21.5;     // 9:30 PM
    takeawayCloseTime = 21.75; // 9:45 PM
  } else if (dayOfWeek === 0) {
    // Sunday
    eatInCloseTime = 19.5;     // 7:30 PM
    takeawayCloseTime = 19.75; // 7:45 PM
  }

  return {
    isEatInOpen: currentTime < eatInCloseTime,
    isTakeawayOpen: currentTime < takeawayCloseTime
  };
}
